import { useController, Control } from 'react-hook-form';

import { SuspendFormValues } from './types';
import {
  createMaxLengthValidator,
  isRequired,
  isValidInput,
} from '../../validators';

export const useControllers = (
  control: Control<SuspendFormValues, any, SuspendFormValues>
) => {
  const {
    field: { value: suspensionCategory, onChange: setSuspensionCategory },
    fieldState: { error: suspensionCategoryError },
  } = useController({
    control,
    name: 'suspensionCategory',
    rules: {
      validate: {
        isRequired,
      },
    },
  });
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(3000),
      },
    },
  });

  return {
    suspensionCategory,
    setSuspensionCategory,
    suspensionCategoryError,
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
